import { render, staticRenderFns } from "./staging-config.vue?vue&type=template&id=546e017c&scoped=true"
import script from "./staging-config.vue?vue&type=script&lang=js"
export * from "./staging-config.vue?vue&type=script&lang=js"
import style0 from "./staging-config.vue?vue&type=style&index=0&id=546e017c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e017c",
  null
  
)

export default component.exports